import React, { createContext, useContext, useState, ReactNode } from 'react';

interface OverlayContextType {
  isOverlayActive: boolean;
  activateOverlay: () => void;
  deactivateOverlay: () => void;
}

const OverlayContext = createContext<OverlayContextType | undefined>(undefined);

export const OverlayProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const [isOverlayActive, setIsOverlayActive] = useState(false);

  const activateOverlay = () => {
    setIsOverlayActive(true);
  };

  const deactivateOverlay = () => {
    setIsOverlayActive(false);
  };

  return (
    <OverlayContext.Provider value={{ isOverlayActive, activateOverlay, deactivateOverlay }}>
      {children}
    </OverlayContext.Provider>
  );
};

export const useOverlay = (): OverlayContextType => {
  const context = useContext(OverlayContext);
  if (context === undefined) {
    throw new Error('useOverlay must be used within an OverlayProvider');
  }
  return context;
};
